import ReactDOM from 'react-dom';
import DigitalCodeApp from './digital-code/DigitalCodeApp';
import { validateCheckout } from './functions';
import ResetSavedData from './digital-code/ResetSavedData';

validateCheckout();
document.addEventListener( 'click', function( e ) {
	if ( e.target.dataset.digitalCodeDeliveryOptionsBtn ) {
		const overlay = document.getElementById( `digital-code-overlay-${ e.target.dataset.itemKey }` );
		if ( ! overlay ) {
			const overlayDelivery = document.getElementById( `react-digital-code-delivery-options-${ e.target.dataset.itemKey }` );
			ReactDOM.render(
				<DigitalCodeApp
					cartItemKey={ overlayDelivery.dataset.itemKey }
					distributionMethod={ overlayDelivery.dataset.distributionMethod }
					selectedDistributionMethod={ overlayDelivery.dataset.selectedDistributionMethod }
					selectedEmails={ overlayDelivery.dataset.selectedEmails }
					quantity={ overlayDelivery.dataset.quantity }
					overlayOpened={ true }
					buttonId={ e.target.id }
				/>,
				overlayDelivery
			);
		}
	}
} );

const removeBtn = document.getElementsByClassName( 'product-remove' );
for ( let i = 0; i < removeBtn.length; i++ ) {
	removeBtn[ i ].addEventListener( 'click', () => {
		let timer = 0;
		const interval = setInterval( () => {
			validateCheckout();
			timer++;
			if ( 10 < timer ) {
				clearInterval( interval );
			}
		}, 500 );
	} );
}

// this code is for get data from local storage when browser go back.
const els = document.getElementsByClassName( 'react-digital-code-delivery-options' );
if ( els.length > 0 ) {
	ReactDOM.render( <ResetSavedData />, els[ 0 ] );
}
